// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationStyleAction.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report page component
 */

!(function() {
  var React = require('react');
  var recompose = require('recompose');
  var withContext = recompose.withContext;
  var getContext = recompose.getContext;
  var compose = recompose.compose;
  var branch = recompose.branch;
  var renderNothing = recompose.renderNothing;
  var mapProps = recompose.mapProps;
  var observer = require('mobx-react').observer;
  const { get, identity, omit } = require('lodash/fp');
  var contextShape = {
    integrationStyle: React.PropTypes.object
  };

  var defineContext = withContext(contextShape, function(props) {
    return {
      integrationStyle: props.integrationStyle
    };
  });

  var accessContext = getContext(contextShape);

  var checkDisplayByKey = function(key) {
    return compose(
      accessContext,
      observer,
      branch(
        function(props) {
          return get(key, props.integrationStyle);
        },
        renderNothing,
        identity
      ),
      mapProps(function(props) {
        return omit('integrationStyle', props);
      })
    );
  };

  module.exports = {
    defineContext: defineContext,
    accessContext: accessContext,
    checkDisplayByKey: checkDisplayByKey
  };
})();



// WEBPACK FOOTER //
// ./ui/pages/Izenda.IntegrationStyleAction.js